import { Box, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import PowerExtensionsClientTable from './PowerExtensionsClientTable'

const header = {
  backgroundColor: 'black',
  color: 'white',
  height: '36px',
  padding: '6px',
  textAlign: 'center',
}

const PowerExtensions = ({ clientsService, powerExtensionService }) => {
  const [client, setClient] = useState()
  const [allClients, setAllClients] = useState([])
  const [allClientsError, setAllClientsError] = useState(false)
  const [allClientsPlaceholder, setAllClientsPlaceholder] =
		useState('Loading...')
  const [portals, setPortals] = useState([])
  const [portalsHidden, setPortalsHidden] = useState(true)
  const [portalsLoading, setPortalsLoading] = useState(false)

  const handleSelectChange = (event, value) => {
    if (value != null) {
      setClient(value.value)
      setPortalsHidden(true)
      setPortalsLoading(true)
      powerExtensionService.getPortals(value.value).then(result => {
        setPortals(result)
        setPortalsHidden(false)
        setPortalsLoading(false)
      })
    } else {
      setClient('')
      setPortalsHidden(true)
    }
  }

  useEffect(() => {
    clientsService
      .getAllClients()
      .then(result => {
        setAllClients(result)
        setAllClientsError(false)
        setAllClientsPlaceholder('Select Clients...')
      })
      .catch(() => {
        setAllClientsError(true)
        setAllClientsPlaceholder('Error loading clients...')
      })
  }, [])

  return (
    <Box padding={5}>
      <Grid container direction="column">
        <Grid item md={6} sm={12}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <p>
								New, streamlined power extension configuration tool coming soon!
              </p>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                data-testid="autocomplete-pe"
                disabled={allClientsError}
                getOptionLabel={option => option.label}
                onChange={handleSelectChange}
                options={allClients}
                renderInput={params => (
                  <TextField
                    {...params}
                    data-testid="text-field-test-pe"
                    error={allClientsError}
                    label={allClientsPlaceholder}
                    placeholder="Clients"
                    variant="standard"
                  />
                )}
              />
            </Grid>
            {portalsLoading && (
              <Grid item xs={12}>
								Loading {client}. . .
              </Grid>
            )}
            {!portalsLoading && !portalsHidden && (
              <Grid item xs={12}>
                <Grid container>
                  <Grid item style={header} xs={4}>
										Portal Code
                  </Grid>
                  <Grid item style={header} xs={4}>
										Portal Name
                  </Grid>
                  <Grid item style={header} xs={4}>
										Locations Associated to Portal
                  </Grid>
                </Grid>
                <PowerExtensionsClientTable
                  client={client}
                  clientsService={clientsService}
                  portals={portals}
                  powerExtensionService={powerExtensionService}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default PowerExtensions
